import Plugin from 'src/plugin-system/plugin.class';

export default class BesteBackergebnissePlugin extends Plugin {

    init() {
        this._registerEvents();
        this._resizeElement();
    }

    _registerEvents() {
        $(this.el).find('button').on('click', () => {
            $(this.el).find('.beste-backergebnisse-widget__back').addClass('is--visible');
        });

        // $( window ).on('resize', () => {
        //     this._resizeElement();
        // });
    }

    _resizeElement() {
        //console.log('resizing');
    }

}